// extracted by mini-css-extract-plugin
module.exports = {"slider":"AddProductsModal_slider__3jfHv","container":"AddProductsModal_container__2u7zC","header":"AddProductsModal_header__1W_gY","tab":"AddProductsModal_tab__13Xwv"};